import { atom } from "recoil";

const clickedBadgeAttendanceAtom = atom({
  key: "clickedBadgeAttendanceState",
  default: false,
});

export default clickedBadgeAttendanceAtom;
